import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  caseStudyInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 0),
    fontSize: 20,
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3, 0),
      gap: theme.spacing(2.5),
    },
  },
  caseStudyInfoItem: {
    '& .MuiTypography-root': {
      fontSize: 16,
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
      },
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.common.black,
      flexShrink: 0,
      fontSize: '1.25rem',
      [theme.breakpoints.up('md')]: {
        fontSize: '1.5rem',
      },
    },
  },
  testimonialContainer: {
    textAlign: 'center',
    padding: theme.spacing(3, 2),
    backgroundColor: '#f5f5f5',
    borderRadius: theme.shape.borderRadius,
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(6, 4),
    },
  },
  testimonialQuote: {
    fontSize: 20,
    fontStyle: 'italic',
    lineHeight: 1.6,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(3),
    fontWeight: 400,
    maxWidth: '800px',
    margin: `0 auto ${theme.spacing(3)} auto`,
    [theme.breakpoints.up('md')]: {
      fontSize: 28,
      lineHeight: 1.5,
      marginBottom: theme.spacing(4),
    },
  },
  testimonialAuthor: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.palette.text.primary,
    [theme.breakpoints.up('md')]: {
      fontSize: 18,
    },
  },
  photoGrid: {
    display: 'grid',
    gridGap: theme.spacing(2),
    gridTemplateColumns: '1fr',
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: '1fr 1fr',
    },
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '1fr 1fr 1fr',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: '1fr 1fr 1fr 1fr',
    },
  },
  photoGridItem: {
    position: 'relative',
    width: '100%',
    height: 250,
    borderRadius: 0,
    overflow: 'hidden',
    [theme.breakpoints.up('md')]: {
      height: 350,
    },
    [theme.breakpoints.up('lg')]: {
      height: 400,
    },
  },
}));
